import React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";

import "./bouncer.scss";

const Bouncer = props => {
  const { dataTestId, size, gray } = props;
  return (
    <div
      data-testid={dataTestId}
      className={gatherClasses(
        props,
        "oui-bouncers",
        `oui-bouncer-${size}`,
        gray ? "oui-gray" : ""
      )}
    >
      <div className="oui-bouncer-1" />
      <div className="oui-bouncer-2" />
      <div className="oui-bouncer-3" />
    </div>
  );
};

Bouncer.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  dataTestId: PropTypes.string,
  gray: PropTypes.bool
};

Bouncer.defaultProps = {
  size: "md",
  dataTestId: "orion-bouncer",
  gray: false
};

Bouncer.displayName = "OrionBouncer";

export default Bouncer;
